import { render, staticRenderFns } from "./reviewer_title.vue?vue&type=template&id=429ebeb8&"
import script from "./reviewer_title.vue?vue&type=script&lang=js&"
export * from "./reviewer_title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports